import { render, staticRenderFns } from "./permissionsInfo.vue?vue&type=template&id=27b27dae&scoped=true"
import script from "./permissionsInfo.vue?vue&type=script&lang=js"
export * from "./permissionsInfo.vue?vue&type=script&lang=js"
import style0 from "./permissionsInfo.vue?vue&type=style&index=0&id=27b27dae&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b27dae",
  null
  
)

export default component.exports